<textarea
    class="form-control input-md multiline-text-field"
    [value]="value()"
    [disabled]="disabled()"
    [readOnly]="readonly()"
    [required]="required()"
    [placeholder]="placeholder()"
    [rows]="rows()"
    [attr.cols]="cols()"
    [attr.minlength]="minLength()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-invalid]="isInvalid()"
    [class.is-valid]="isValid()"
    [class.is-invalid]="isInvalid()"
    (input)="onInput($event)"
    (blur)="touched.set(true)"
></textarea>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
